import { ROUTES } from './routes';

/**
 * Primary site navigation.
 *
 * Consumed by both the desktop header and the mobile drawer so the two can
 * never fall out of sync. `label` doubles as the visible text and the
 * accessible name.
 */
export const primaryNavigation = [
  { label: 'Home', to: ROUTES.home },
  { label: 'Services', to: ROUTES.services },
  { label: 'Industries', to: ROUTES.industries },
  { label: 'How It Works', to: ROUTES.howItWorks },
  { label: 'About', to: ROUTES.about },
  { label: 'Contact', to: ROUTES.contact },
];

/** Footer column: services quick links (deep links into the Services page). */
export const footerServiceLinks = [
  { label: 'Monthly Bookkeeping', to: `${ROUTES.services}#monthly-bookkeeping` },
  {
    label: 'Bank & Credit Card Reconciliation',
    to: `${ROUTES.services}#bank-credit-card-reconciliation`,
  },
  {
    label: 'Catch-Up Bookkeeping',
    to: `${ROUTES.services}#catch-up-bookkeeping`,
  },
  {
    label: 'Bookkeeping Cleanup',
    to: `${ROUTES.services}#bookkeeping-cleanup`,
  },
  {
    label: 'Accounts Payable Support',
    to: `${ROUTES.services}#accounts-payable-support`,
  },
  {
    label: 'Accounts Receivable Support',
    to: `${ROUTES.services}#accounts-receivable-support`,
  },
  { label: 'Financial Reporting', to: `${ROUTES.services}#financial-reporting` },
  { label: 'CPA-Ready Books', to: `${ROUTES.services}#cpa-ready-books` },
];

/** Footer column: company links. */
export const footerCompanyLinks = [
  { label: 'About', to: ROUTES.about },
  { label: 'Industries We Serve', to: ROUTES.industries },
  { label: 'How It Works', to: ROUTES.howItWorks },
  { label: 'Contact', to: ROUTES.contact },
];

/** Footer column: legal links. */
export const footerLegalLinks = [
  { label: 'Privacy Policy', to: ROUTES.privacy },
  { label: 'Terms of Use', to: ROUTES.terms },
];

export default primaryNavigation;
